import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, apiError } from '../../lib/api';

export default function EmployeeListings() {
  const [list, setList] = useState([]);
  const [err, setErr] = useState('');
  const [edit, setEdit] = useState(null);

  const load = async () => { try { const {data} = await api.get('/employee/businesses'); setList(data.businesses||[]); } catch(e){ setErr(apiError(e)); } };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = { name: edit.name, tagline: edit.tagline, description: edit.description, phone: edit.phone, whatsapp: edit.whatsapp, address: edit.address };
      await api.put(`/employee/businesses/${edit.id}`, payload);
      setEdit(null); await load();
    } catch (e) { alert(apiError(e)); }
  };

  return (
    <div data-testid="employee-listings">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">My listings</h2>
        <Link to="/employee/add" className="btn-ap" data-testid="add-listing-link">Add listing</Link>
      </div>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead><tr><th>Name</th><th>Category</th><th>City</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {list.map(b => (
              <tr key={b.id} data-testid={`emp-biz-${b.id}`}>
                <td><Link to={`/business/${b.slug}`}>{b.name}</Link></td>
                <td>{b.category_name}</td>
                <td>{b.city_name}</td>
                <td><span className={'pill pill-'+b.status}>{b.status}</span></td>
                <td><button className="btn-ap-outline btn-sm" onClick={()=>setEdit(b)} data-testid={`edit-${b.id}`}>Edit</button></td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="5" className="text-center py-4 text-muted-2">No listings yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {edit && (
        <div className="position-fixed top-0 start-0 w-100 h-100" style={{ background:'rgba(0,0,0,.5)', zIndex:60 }} onClick={()=>setEdit(null)}>
          <div className="ap-card mx-auto mt-5" style={{ maxWidth: 640 }} onClick={e=>e.stopPropagation()}>
            <h4>Edit listing</h4>
            <form onSubmit={save}>
              <input className="form-control mb-2" value={edit.name} onChange={e=>setEdit({...edit,name:e.target.value})} data-testid="edit-name"/>
              <input className="form-control mb-2" placeholder="Tagline" value={edit.tagline||''} onChange={e=>setEdit({...edit,tagline:e.target.value})} data-testid="edit-tagline"/>
              <textarea className="form-control mb-2" rows={3} value={edit.description||''} onChange={e=>setEdit({...edit,description:e.target.value})} data-testid="edit-desc"/>
              <input className="form-control mb-2" placeholder="Phone" value={edit.phone||''} onChange={e=>setEdit({...edit,phone:e.target.value})} data-testid="edit-phone"/>
              <input className="form-control mb-2" placeholder="WhatsApp" value={edit.whatsapp||''} onChange={e=>setEdit({...edit,whatsapp:e.target.value})} data-testid="edit-wa"/>
              <input className="form-control mb-3" placeholder="Address" value={edit.address||''} onChange={e=>setEdit({...edit,address:e.target.value})} data-testid="edit-addr"/>
              <div className="d-flex gap-2">
                <button className="btn-ap" data-testid="edit-save">Save</button>
                <button type="button" className="btn-ap-outline" onClick={()=>setEdit(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
